export const appDefaults = {
  api: {
    limit:  30,
    offset: 1
  }
}
